// Scripts
import toastr from 'toastr'
import { loading } from '../libs/utils.js'

// Styles
import '../../scss/components/forms'
import '../../scss/components/toast'

// Setup
const settings = require('../../common.json')

// Locations Autocomplete
function getAgencyLocAutocomplete (formEl) {
  import(/* webpackChunkName: "agenciesLocationsAutocomplete" */ './agenciesLocationsAutocomplete.js').then(module => {
    module.agenciesLocationsAutocomplete.init(formEl)
  })
}

const agencySearchForm = {

  locate (form, d, s) {
    loading(form)
    const data = new FormData()
    data.append('department', d)
    data.append('slug', s)
    fetch(document.location.origin + '/nos-agences/locate', {
      method: 'POST',
      headers: new Headers({
        'X-Requested-With': 'XMLHttpRequest'
      }),
      body: data
    }).then(response => {
      if (response.status === 200) {
        response.json().then(data => {
          toastr.remove()
          document.location = document.location.origin + '/nos-agences/' + data.agency
        })
      } else {
        toastr.remove()
        toastr.error(settings.messages.errors.retry)
      }
      loading(form, false)
    })
  },

  initForm (form) {
    // autocomplete
    const loadAutoComplete = function (e) {
      const form = e.target.closest('form')
      const el = e.target
      el.blur()
      el.setAttribute('disabled', 'disabled')
      el.value = 'Veuillez patienter...'

      // remove all listeners to close button : https://stackoverflow.com/questions/19469881/remove-all-event-listeners-of-specific-type
      const elClone = el.cloneNode(true)
      el.parentNode.replaceChild(elClone, el)
      getAgencyLocAutocomplete(form)
    }
    const location = form.querySelector('input[name="location"]')
    if (!location.classList.contains('autocomplete_initialized')) {
      location.addEventListener('click', loadAutoComplete)
      location.addEventListener('keyup', loadAutoComplete)
      location.addEventListener('focus', loadAutoComplete)
    }

    // on submit
    form.addEventListener('submit', e => {
      const self = this
      const form = e.target
      const location = form.querySelector('input[name="location"]').value
      const department = form.querySelector('input[name="department"]').value
      if (location !== '' && department !== '') {
        e.preventDefault()
        const slug = form.querySelector('input[name="slug"]').value
        self.locate(form, department, slug)
      }
    })
  },

  init () {
    const self = this
    const forms = document.querySelectorAll('form[name="asForm"]')
    forms.forEach(form => {
      self.initForm(form)
    })
  }

}

agencySearchForm.init()
